export class ConstantsUtility {
  private constructor() {}

  static readonly appName: string = 'Sciper'

  static readonly authClientId: string = 'sciper'
  static readonly authScopes: string =
    'openid email profile roles offline_access job.read job.write'

  static readonly adminRole: string = 'sciper-admin'

  static readonly httpPrefix = 'http://'
  static readonly httpsPrefix = 'https://'

  static readonly googlePlayStoreLink =
    'https://play.google.com/store/apps/details?id=de.uas7.sciper'
  static readonly appleAppStoreLink =
    'https://apps.apple.com/us/app/sciper/id6745272025'

  static readonly supportMailAddress = 'app@uas7.org'
  static readonly supportMailSubject = 'Sciper-App'

  static readonly toastDuration: {
    short: number
    medium: number
    long: number
  } = {
    short: 2000,
    medium: 4000,
    long: 10000,
  }
}
